export default {"src":"/_next/static/media/search.0afc620f.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};